import React, { useEffect, useState, useRef } from 'react';
import {connect} from 'react-redux';
import {useHistory, Link} from 'react-router-dom';
import styles from './Collection.scss';
import breadCrumbStyle from '../Breadcrumbs/Breadcrumbs.scss';
import PropTypes from 'prop-types';
import Loading from '../Loading/Loading';
import {getCollectionProperties, deleteCollections, showModal} from '../../actions';
import RemoveCollection from '../Modal/CollectionModal/RemoveCollection';
import PropertyCardSearch from '../PropertyCard/PropertyCardSearch';
import CollectionModal from '../Modal/CollectionModal/CollectionModal';
import CollectionCardDropDown from '../Collections/CollectionCardDropDown';
import {breakpointMdHigh} from '../../lib/config';
import ShareDropdown from '../ShareDropdown/ShareDropdown';
import LoginModal from '../Modal/LoginModal/LoginModal';
import {isOnMobileDevice} from '../../lib/share';
import {propertyFormat} from '../../lib/propertyFormat';

const Collections = (props) => {
  const {
    getCollectionProperties,
    deleteCollections,
    collections,
    user
  }  = props;

  const [showShareDropdown, setShowShareDropdown] = useState(false);
  const [collectionPath, setCollectionPath] = useState('');

  const [showRemoveCollectionModal, setShowRemoveCollectionModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDropDown, setShowDropDown] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const menuRef = useRef(null);
  const history = useHistory();
  const search = typeof window !== 'undefined' && window.location.search;
  const params = new URLSearchParams(search);
  const uuid = params.get('id');

  const getCollectionDetail = () => {
    getCollectionProperties({collectionUuid: uuid});
  };

  const removeCollection = () => {
    deleteCollections({ collectionUuid: uuid});
    history.push('/members/savedproperties');
  };

  const collectionList = () =>
    collections.collection.properties.length > 0 ? collections.collection.properties.map(property =>
      <PropertyCardSearch property={propertyFormat(property)} isFromCollection={true} key={property.name} />
    ) :
      <div className={'text-center mt-4 w-100'}>There are no properties on your list</div>;


  useEffect(() => {
    getCollectionDetail();
    setCollectionPath(window.location.pathname + window.location.search);
  }, []);

  useEffect(() => {
    setIsMobile(typeof window !== 'undefined' && window.innerWidth <= breakpointMdHigh);
  }, []);

  const isReadOnly = !user.authenticated || (!_.isEmpty(collections.collection) && user.currentUser.uuid !== collections.collection.consumerUuid);

  const handleShowShareDropdownChange = () => {
    if (navigator.share && isOnMobileDevice(navigator)) {
      navigator.share({
        title: collections.collection.name,
        text: 'Check out this collection on OnTheHouse: ',
        url: window.location.href,
      }).then(() => {});
    } else {
      setShowShareDropdown(!showShareDropdown);
    }
  };

  const renderBreadCrumbs = () => (
    <div className={'mui-bg ' + breadCrumbStyle.breadCrumbs}>
      <Link to="/members/savedproperties">Saved Properties</Link>
      <span className={'mr-1 ' + breadCrumbStyle.arrowRight} />
      <span>{collections.collection && collections.collection.name}</span>
    </div>
  );

  const createCollection = (event) => {

    if(user.authenticated) {
      window.location.href = '/members/savedProperties';
    } else {
      event.preventDefault();
      props.showModal({
        open: true,
        title: 'Sign in to your account',
        component: <LoginModal />
      });
    }
  };

  const renderCollectionNotFound = () => <div className={`mt-5 ${styles.noCollection}`}>
    <h2>Collection has been removed</h2>
    <label onClick={(event) => createCollection(event)}>Create your own collection</label>
  </div>;

  return (collections.collectionStatus === 'fetching' ? <Loading/> :
    collections.collectionStatus !== 'failure' ?
      <div>
        <div className={styles.breadcrumb}>
          {isReadOnly ?
            <span style={{color: '#00000099'}}>
              Check out this collection that&apos;s been shared with you
            </span> :
            renderBreadCrumbs()
          }
        </div>

        { isMobile ?
          <div className={'d-flex justify-content-between align-items-center mb-3'}>
            <h1 className={'mb-0'}>{collections.collection && collections.collection.name}</h1>
            {isReadOnly ? <label onClick={(event) => createCollection(event)}>Create your own collection</label> :
              <button className={styles.mobileMenu} ref={menuRef} onClick={() => setShowDropDown(!showDropDown)} /> }
          </div>
          :
          <div className={'d-flex justify-content-between '}>
            <div className={styles.header}>
              <h1>{collections.collection && collections.collection.name}</h1>
              {isReadOnly ? <label onClick={(event) => createCollection(event)}>Create your own collection</label> :
                <button onClick={() => setShowEditModal(true)} />}
            </div>

            {!isReadOnly && <div className={styles.actionButtons}>
              <button ref={menuRef} className={styles.share} onClick={handleShowShareDropdownChange}>
                Share Collection
              </button>
              <button className={styles.delete} onClick={() => setShowRemoveCollectionModal(true)}>
                Remove Collection
              </button>
            </div>}

          </div>
        }

        <div className={styles.list + ' mt-4'}>
          {collections.collection && collections.collection.properties && collectionList()}
        </div>

        <CollectionModal
          showModal={showEditModal}
          toggleModal={() => setShowEditModal(false)}
          modalMode={'EDIT'}
          exitOnSave={true}
          collectionUuid={collections.collection && collections.collection.collectionUuid}
          collectionName={collections.collection && collections.collection.name}
        />
        <RemoveCollection
          showModal={showRemoveCollectionModal}
          toggleModal={() => setShowRemoveCollectionModal(false)}
          onRemoveCollection={() => removeCollection()}
        />
        <CollectionCardDropDown
          ref={menuRef}
          open={showDropDown}
          onCloseHandler={() => setShowDropDown(false)}
          onUpdate={() => setShowEditModal(true)}
          onDelete={() => setShowRemoveCollectionModal(true)}
          onShare={() => handleShowShareDropdownChange()}
          collectionName={collections.collection && collections.collection.name}
        />

        <ShareDropdown
          pathname={collectionPath}
          open={showShareDropdown}
          onCloseHandler={handleShowShareDropdownChange}
          ref={menuRef}
          isFromCollection={true}
          collectionName={collections.collection?.name || 'Share Collection'}
        />
      </div> : renderCollectionNotFound()
  );
};

Collections.propTypes = {
  userFavourites: PropTypes.object,
  collections: PropTypes.object,
  getCollectionProperties: PropTypes.func,
  user: PropTypes.object,
  showModal: PropTypes.func,
  deleteCollections: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    userFavourites: state.userFavourites,
    collections: state.collections,
    user: state.user,
  };
};

const mapDispatchToProps = {
  getCollectionProperties,
  showModal,
  deleteCollections
};

export default connect(mapStateToProps, mapDispatchToProps)(Collections);
